/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-unsafe-call */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/**
 * 自营老户升级卡片
 */
import { Component, Mixins } from 'vue-property-decorator';
import { UpgradeStateEnum } from '@/enums/autarkyUpgrade';
import FinanceBusiness from '@/mixins/finance-business';
import { Notify } from 'vant';
import { Toast } from '@hb/coffee';
import { namespace } from 'vuex-class';
import RouterHelper from '@/shared/utils/routerHelper';
import { HomeThemeEnums, getHomeThemeBodyConfig } from '@/shared/utils/pageTheme';
import { formatCreditAmount } from '../utils';
import ThemeBanner from '../theme-banner';
import IdentityExpiresBar from '../identity-expires-bar';

import style from './index.module.scss';

const HomeStore = namespace('home');

@Component
export default class AutarkyUpgradeCard extends Mixins(
  FinanceBusiness,
) {
  @HomeStore.Action getCreditData!: (shouldRefresh?: boolean) => Promise<void>;

  @HomeStore.State homeThemeType!: HomeThemeEnums | null;

  @HomeStore.Getter isExperimentA!: boolean;

  // 是否升级中
  private get isSubmit() {
    return this.autarkyState && this.autarkyState.autarkyUpgradeState === UpgradeStateEnum.SUBMIT;
  }

  /** 已授信，无可用额度专属卡片展示 */
  private get isUnavailableAmountCard(): boolean {
    const { creditStatus, creditAmount } = this.creditData || {};

    return creditStatus && Number(creditAmount) === 0;
  }

  /** 去提现 */
  private loan() {
    this.$ubtPageButtonNew('finance_loan_upgradeAPage_apply');
    this.$emit('loan');
  }

  // 申请额度
  private onApplyCreditHandler(buttonName: string) {
    this.onApplyCredit(`finance_upgradeAPage_${buttonName}`);
  }

  // 去升级或刷新页面
  private async goUpgrade() {
    if (this.isSubmit) {
      this.$ubtPageButton('finance_upgradeAPage_refreash_process');
      Toast.loading({
        message: '加载中...',
        forbidClick: true,
      });
      await this.getCreditData();
      Toast.clear();
      const { autarkyUpgradeState } = this.autarkyState || {};
      if (autarkyUpgradeState && autarkyUpgradeState === UpgradeStateEnum.SUBMIT) {
        Notify('升级审批中，请稍后再试！');
      } else {
        RouterHelper.backHome();
      }
    } else {
      const { progressingTaskId } = this.creditData || {};
      if (progressingTaskId) {
        Notify('当前有未完成的授信审批，待审批完成后重新提交升级申请！');
        return;
      }
      this.onApplyCreditHandler(this.isUnavailableAmountCard ? 'unavailable_upgrade' : 'upgrade');
    }
  }

  private get upgradeBtnText(): string {
    if (this.isSubmit) {
      return '升级申请审核中';
    }
    if (this.isExperimentA) {
      return '去提现';
    }
    return '立即升级';
  }

  private mounted() {
    if (this.isExperimentA) {
      this.$ubtModuleExposeNew('finance_loan_upgradeAPage_apply');
    } else if (this.isUnavailableAmountCard) {
      this.$ubtModuleExposeNew('finance_upgradeAPage_unavailable_upgrade');
    }
  }

  private renderUpgradeButtons() {
    return (
      <div
        class={[style.goUpgrade, !this.isSubmit && style.animateBtn]}
        onClick={this.isExperimentA ? this.loan.bind(this) : this.goUpgrade.bind(this)}>
        {this.upgradeBtnText}
        <p class={style.arrow} />
      </div>
    );
  }

  private renderRateExplain() {
    const { rateFloor, rateCeil } = this.businessInfoExtra?.creditInfo || {};
    return (
      <div class={style.rate}>综合年化利率(单利){rateFloor}%-{rateCeil}%</div>
    );
  }

  private render() {
    const themeBannerConfig = getHomeThemeBodyConfig(this.homeThemeType, this.$route.name);
    const { isValidTheme, bgTransitionStyle } = themeBannerConfig;
    const { identityExpiresFor30 } = this.creditData || {};

    return (
      <div
        class={[style.autarkyUpgradeCard, isValidTheme && style.customeThemeBox]}
        style={[isValidTheme && bgTransitionStyle]}
      >
        <ThemeBanner themeConfig={themeBannerConfig} />
        {
          /** 无可用额度专属卡片 */
          this.isUnavailableAmountCard ? (
            <div class={style.unavailableAmountCard}>
              <div class={style.amountLine}>
                <div class={style.before}>
                  <p class={style.lineText}>当前</p>
                  <p class={style.lineText}>无可用额度</p>
                </div>
                <div class={style.after}>
                 <div class={style.upgradeTitleBox}>
                  <span class={style.upgradeIcon}>升级后</span>
                  <span class={style.upgradeText}>最高可借(元)</span>
                 </div>
                 <p class={style.encryptAmount}>??,000</p>
                </div>
              </div>
              {this.renderRateExplain()}
              {this.renderUpgradeButtons()}
              {/** 身份证有效期小于30天，提醒用户更新bar */}
              <IdentityExpiresBar visible={identityExpiresFor30} />
            </div>
          ) : (
            /** 有可用额度通用卡片 */
            <div class={style.availableAmountCard}>
              <div class={style.amountLine}>
                <div class={[style.before, style.amountComnonBox]}>
                  <p class={style.beforeAmount}>
                    {this.creditData ? formatCreditAmount(Number(this.creditData.creditAmount), 0) : '0'}
                  </p>
                  <p class={style.amountTips}>已有额度(元)</p>
                </div>
                <div class={[style.after, style.amountComnonBox]}>
                  <p class={style.afterAmount}>*****</p>
                  <p class={style.amountTips}>尊享额度(元)</p>
                </div>
              </div>
              {this.renderRateExplain()}
              {this.renderUpgradeButtons()}
              {/** 身份证有效期小于30天，提醒用户更新bar */}
              <IdentityExpiresBar visible={identityExpiresFor30} />
            </div>
          )
        }
        {// 挂载身份证清晰分不够弹窗 dom
          this.getUpdatedIdentityPhotoDialog()
        }
      </div>
    );
  }
}
